/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".welcome-banner[_ngcontent-%COMP%]{background-image:linear-gradient(to bottom,#0d5a8b,#126ea9)}.banner-image[_ngcontent-%COMP%]{width:326px;height:107px;-o-object-fit:contain;object-fit:contain}.welcome-icon[_ngcontent-%COMP%]{width:120px;height:120px;-o-object-fit:contain;object-fit:contain}\n/*# sourceMappingURL=mobile-banner.component.css.map*/"];
export { styles as styles };
